import {Trans} from 'react-i18next'
import messages from '../../../../../assets/messages'
import {PasswordValidationResult} from '../../../../../graphql/types'
import {Container} from './components/Container'
import {ValidationResult} from './components/ValidationResult'

type ErrorListProps = {
  passwordValidationResult?: PasswordValidationResult
}

export const ErrorList = ({passwordValidationResult}: ErrorListProps) => {
  if (!passwordValidationResult) return null
  if (passwordValidationResult?.isValid) return null
  const {config, errors} = passwordValidationResult

  return (
    <Container>
      <ValidationResult
        erroneous={
          !!(
            errors?.minLength || errors?.maxLength
          )
        }
        validation={
          <Trans
            {...messages.passwordLengthValidation}
            values={{
              minLength: config.minLength,
              maxLength: config.maxLength,
            }}
          />
        }
      />
      {config.uppercase && <ValidationResult
        erroneous={!!errors?.uppercase}
        validation={<Trans {...messages.uppercaseValidation} />}
      />}
      {config.lowercase && <ValidationResult
        erroneous={!!errors?.lowercase}
        validation={<Trans {...messages.lowercaseValidation} />}
      />}
      {config.numbers && <ValidationResult
        erroneous={!!errors?.numbers}
        validation={<Trans {...messages.numberValidation} />}
      />}
      {config.symbols && <ValidationResult
        erroneous={!!errors?.symbols}
        validation={<Trans {...messages.symbolsValidation} />}
      />}
      <ValidationResult
        erroneous={!!errors?.passwordsMatch}
        validation={<Trans {...messages.passwordMatchValidation} />}
      />
    </Container>
  )
}
